module.exports = __webpack_public_path__ + "img/reviews-author-13@2x.91e8ec8.jpg";